import React from "react";
import  './Resources/Actions.css';
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function Changes(){

    const navigate = useNavigate();
    const APP_NAME = process.env.REACT_APP_NAME;
    
    return (
        <div style = {{height:"100%", width:"100%"}}>
            <div className="reportheader">{APP_NAME} </div>
            <div style={{ width:"100%",height:"30px",paddingLeft:"10px" ,
            backgroundColor:"goldenrod", color:"white",textAlign:"center",fontSize:"20px"}}> Delete/Modify </div>
            <Navbar/>
            <fieldset><legend>Modify</legend>
                {/*div className="styles" style ={{marginTop:"5px",marginBottom:"15px"}} onClick={()=>{navigate('/editloan')}}> Modify Loan</div>*/}
                <div className="styles" style ={{marginTop:"5px",marginBottom:"15px"}} onClick={()=>{navigate('/editexpensehead')}}> Modify ExpenseHead</div>
            </fieldset>
            
            <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/deleteloan')}}> Delete Loan</div>
            <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/editreceipt')}}>Delete Receipt</div>
            {/*<div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/home')}}>Delete Fine</div>*/}
            <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/deleteexpense')}}> Delete Expense</div>
            <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/deletedeposit')}}> Delete Deposit</div>
            
            <div className="backbutton" style ={{marginTop:"30px"}} onClick={()=>{navigate('/home')}}>Home</div>
            </div>
    )
}